import React from 'react';
import styled, { keyframes } from 'styled-components';

const spin = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

const SpinnerWrapper = styled.div`
  display: inline-block;
  height: 25px;
  position: fixed;
  right: 8px;
  top: 8px;
  width: 25px;
`;

const Spinner = styled.div`
  animation: ${spin} 1s ease-in-out infinite;
  border: 4px solid transparent;
  border-radius: 50%;
  border-top: 4px solid ${({ color }) => color || 'var(--color-accent-primary-default)'};
  height: 100%;
  left: 0;
  position: absolute;
  top: 0;
  width: 100%;
`;

const InnerCircle = styled.div`
  animation: ${spin} 1.5s linear infinite reverse;
  border: 3px solid ${({ color }) => color || 'var(--color-accent-primary-default)'};
  border-bottom: 3px solid transparent;
  border-radius: 50%;
  height: 60%;
  left: 20%;
  position: absolute;
  top: 20%;
  width: 60%;
`;

const PageLoader = ({ color }) => {
  return (
    <SpinnerWrapper>
      <Spinner color={color} />
      <InnerCircle color={color} />
    </SpinnerWrapper>
  );
};

export { PageLoader };
